import { Divider, Fab, Grid, IconButton, Paper, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, Theme, Typography, withStyles } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import React, { useDispatch, useGlobal } from 'reactn';
import IForfettariAppBar from '../../appBar/IForfettariAppBar';
import Main from '../../components/main';
import '../../css/media-query-styles.css';
import OpenIcon from '@material-ui/icons/LockOpen';
import BlockIcon from '@material-ui/icons/Lock';
import RestoreIcon from '@material-ui/icons/Restore';
import AddIcon from '@material-ui/icons/Add';
import SearchIcon from '@material-ui/icons/Search';
import { Applicazioni } from '../../types/types';
import { IGlobalState, InEditingMode } from '../../states/GlobalState';
import { WhatsNew, WhatsNewSearchModel } from '../../models/whatsNew';
import TablePaginationActions from '../../pagination/TablePaginationActions';
import { useHistory } from 'react-router-dom';
import { getWhatsNews, getWhatsNew, closeWhatsNew, openWhatsNew } from '../../services/whatsNewServices';
import { useLogger } from '../../logger';
import { useEffect } from 'react';
import ConfirmDialog from '../../dialog/ConfirmDialog';
import { motion } from 'framer-motion';
import { globalStyles } from '../../style/GlobalStyles';

const useStyles = makeStyles((theme: Theme) => createStyles({
  tableContainer: {
      width: "100%",
      marginTop: theme.spacing(3),
      overflowX: "auto",
  },
  table: {
      minWidth: 700,
  },
  tablerow: {
      cursor: 'pointer',
  },
  filterContainer: {
      paddingLeft: theme.spacing(2),
      paddingBottom: theme.spacing(0),
      display: 'flex',
  },
  fab: {
    textAlign: 'right'
  },
  buttonIcon: {
    margin: "1rem",
    cursor: "pointer"
  },
}));

const CustomBlockIcon = withStyles((theme: Theme) => createStyles({
  root: {
      fontSize: 20,
      color: theme.palette.secondary.main,
  },
}))(BlockIcon);
const ExpiredIcon = withStyles((theme: Theme) => createStyles({
  root: {
      fontSize: 20,
      color: theme.palette.primary.light,
  },
}))(RestoreIcon);
const CustomTableCellForIcon = withStyles((theme: Theme) => createStyles({
  body: {
      fontSize: 20,
      textAlign: 'center',
      color: theme.palette.secondary.main,
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      paddingTop: theme.spacing(0.25),
      paddingBottom: theme.spacing(0),
      borderLeft: 'solid 1px #c0c0c0'
  },
}))(TableCell);
const CustomTableCell = withStyles((theme: Theme) => createStyles({
  head: {
      fontSize: 14,
      // backgroundColor: theme.palette.common.black,
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.common.white,
      paddingLeft: theme.spacing(1),
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      borderLeft: 'solid 1px #c0c0c0',
  },
  body: {
      fontSize: 14,
      paddingLeft: theme.spacing(1),
      paddingTop: theme.spacing(0.25),
      paddingBottom: theme.spacing(0.25),
      borderLeft: 'solid 1px #c0c0c0'
  },
}))(TableCell);
const CustomTableRow = withStyles((theme: Theme) => createStyles({
  root: {
      color: "inherit",
      display: "table-row",
      outline: "none",
      verticalAlign: "middle",
      height: 28,
  },
}))(TableRow);

export default function WhatsNewIndex() {
    // eslint-disable-next-line
    const classes = useStyles();
    const gClasses = globalStyles();
    const dispatch = useDispatch();
    const history = useHistory();
    const [pagination, setPagination] = useGlobal<IGlobalState, 'whatsNewPagination'>('whatsNewPagination');
    const [filteredWhatsNews, setFilteredWhatsNews] = useGlobal<IGlobalState, 'filteredWhatsNews'>('filteredWhatsNews');
    const [loadingWhatsNews, setLoadingWhatsNews] = useGlobal<IGlobalState, 'loadingWhatsNews'>('loadingWhatsNews');
    const [globalWait, setGlobalWait] = useGlobal<IGlobalState, 'globalWait'>('globalWait');
    const [,setApplication] = useGlobal<IGlobalState, 'application'>('application');
    const [ip,] = useGlobal<IGlobalState, 'ip'>('ip');
    const [auth,] = useGlobal<IGlobalState, 'auth'>('auth');
    const [confirmDialogOpen, setConfirmDialogOpen] = React.useState(false)
    const [openConfirmDialogOpen, setOpenConfirmDialogOpen] = React.useState(false)
    const [newsInClosing, setNewsInClosing] = React.useState<WhatsNew | null>(null);
    const logger = useLogger({key: 'whatsNew'});
    let model: WhatsNewSearchModel = new WhatsNewSearchModel();
    //paginazione lato server
    let queryTitle: string = ''
    let queryId: number = 0
    let pageDirection: string = 'forward'
    
    const _handleChangePage = (ev: React.MouseEvent<HTMLButtonElement> | null, page: number) => {
        debugger;
        setPagination({...pagination, page});
        if (page > pagination.page) {
            pagination.direction = 'forward';
            queryTitle = filteredWhatsNews && filteredWhatsNews.length > 0 ? filteredWhatsNews.slice(-1)[0].Title : '';
            queryId =filteredWhatsNews && filteredWhatsNews.length > 0 ? filteredWhatsNews.slice(-1)[0].Id : 0;
            pageDirection = 'forward';
        }
        else
        {
            pagination.direction = 'back';
            queryTitle = filteredWhatsNews && filteredWhatsNews.length > 0 ? filteredWhatsNews[0].Title : '';
            queryId = filteredWhatsNews && filteredWhatsNews.length > 0 ? filteredWhatsNews[0].Id : 0;
            pageDirection = 'back';
        }

        model.QueryTitle = queryTitle;
        model.QueryId = queryId;
        model.PageDirection = pageDirection;

        handleSearch();
    }
    const _handleChangeRowsPerPage = (ev: React.ChangeEvent<HTMLTextAreaElement|HTMLInputElement>) => setPagination({...pagination, rowsPerPage: parseInt(ev.target.value)})
    
    const _handleRowClick = (ev: React.MouseEvent<HTMLTableRowElement, MouseEvent>, whatsNew: WhatsNew) => {
        if(globalWait) {return;}
        console.log({ev});
        console.log(`_handleRowClick.${whatsNew.Id}`, {whatsNew})
        setGlobalWait(true);
        getWhatsNew(ip, auth.authData!, auth.user!, whatsNew.Id).then((p: WhatsNew)  => {
            if(p) {
                dispatch.setCurrentEditWhatsNewAndMode(p, 'Edit');
                history.push(`/whatsNewDetail/${whatsNew.Id}`);
            } else {
                // notifyUser(`WhatsNew con oid = ${whatsNew.Id} non trovata`, 'error')
                logger.error('Errore in recupero whatsNew non trovata avente id: ' + whatsNew.Id);
            }
        }).finally(() => setGlobalWait(false));
    }
    
    const handleCloseNews = (event: React.MouseEvent<SVGSVGElement, MouseEvent>, item: WhatsNew) => {
        console.log('item: ' + item.Id);
        setNewsInClosing(item);
        event.stopPropagation();
        setConfirmDialogOpen(true);
    }
    
    const handleOpenNews = (event: React.MouseEvent<SVGSVGElement, MouseEvent>, item: WhatsNew) => {
        console.log('item: ' + item.Id);
        setNewsInClosing(item);
        event.stopPropagation();
        setOpenConfirmDialogOpen(true);
    }

    const closeConfirmDialog = (event: {}) => setConfirmDialogOpen(false)
    const closeOpenConfirmDialog = (event: {}) => setOpenConfirmDialogOpen(false)

    const confirmCloseNews = (context?: any) => {
        console.log('context: ' + context);
        setConfirmDialogOpen(false);
        // TODO
        closeWhatsNew(ip, auth.authData!, auth.user!, newsInClosing!.Id).then(res => {
            console.log('Ho chiuso la news avente Id: ' + res.Id);
            dispatch.whatsNewSaved(res);

        });
    }
    
    const confirmOpenNews = (context?: any) => {
        console.log('context: ' + context);
        setOpenConfirmDialogOpen(false);
        // TODO
        openWhatsNew(ip, auth.authData!, auth.user!, newsInClosing!.Id).then(res => {
            console.log('Ho chiuso la news avente Id: ' + res.Id);
            dispatch.whatsNewSaved(res);

        });
    }
    
    const handleAdd = () => {
        console.log('*** +++ handleAdd')
        const newOid = 0;
        // const ownerDefault = adOwnerContext
        // const livelloDefault = adLevels ? adLevels[0].value as number : 0;
        
        //GESTIRE NELLO STATO ma da fare prima ??
        dispatch.createNewWhatsNew(newOid);
        history.push(`/whatsNewDetail/${newOid}`);
    }

    const handleSearch = () => {
        setLoadingWhatsNews(true);
        // model.BusinessName = "WKI";
        getWhatsNews(ip, auth.authData!, auth.user!, model).then(res => {
            console.log('Ritorno le whatsNew ' + JSON.stringify(res));            
            setFilteredWhatsNews(res.ResultList as WhatsNew[]);
            if (res.ResultList && res.ResultList.length > 0) {
                pagination.rows = res.ListLength;
            }
        }).catch(error => {
            logger.error('Errore in recupero whatsNew: ' + error.statusText);
        })
        .finally(() => setLoadingWhatsNews(false));
    }
    
    useEffect(() => {
        queryTitle = pagination.querySurname;
        queryId = pagination.queryId;
        
        setApplication(Applicazioni.WhatsNew);
    }, []);
    
    return (
    <div style={{ backgroundColor: "#e3e3e3", minHeight: "100vh" }}>
        <IForfettariAppBar title="Gestione WhatsNew" handleLoad={() => {}}></IForfettariAppBar>
        <Main>
            <div className={gClasses.rootModel}>
                <motion.div 
                    initial={{opacity: 0}}
                    animate={{opacity: 1}}
                    transition={{ delay: 0.5, duration: 1.5}}
                    style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start'}}>
                    {/* <div style={{ flex: '1 1' }}>&nbsp;</div> */}
                    <div style={{ flex: '0 1' }}>
                        <Fab color='default' size='small' className={classes.fab} onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => handleAdd()}>
                            <AddIcon titleAccess="Aggiungi whatsNew"/>
                        </Fab>
                    </div>
                    &nbsp;
                    <div style={{ flex: '0 1' }}>
                        {/* <Fab color='default' size='small' className={classes.fab} onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => handleAdd()}><AddIcon /></Fab> */}
                        <Fab color='default' size='small' className={classes.fab} onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
                            pageDirection = 'forward'
                            queryTitle= '';
                            queryId = 0;
                            handleSearch()
                        }}
                        >
                            <SearchIcon titleAccess="Ricerca whatsNew"/>
                        </Fab>
                    </div>
                </motion.div>
                <Paper className={classes.tableContainer}>
                    <Table className={classes.table} size='small'>
                        <TableHead>
                            <TableRow>
                                <CustomTableCell>Id</CustomTableCell>
                                <CustomTableCell>Versione</CustomTableCell>
                                <CustomTableCell>Titolo</CustomTableCell>
                                <CustomTableCell>Html content</CustomTableCell>
                                <CustomTableCell>Data fine</CustomTableCell>
                                <CustomTableCell>Azioni</CustomTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {!loadingWhatsNews && filteredWhatsNews && filteredWhatsNews.length 
                            //? (filteredWhatsNews.slice(pagination.page * pagination.rowsPerPage, pagination.page * pagination.rowsPerPage + pagination.rowsPerPage).map(whatsNew => (
                            ? (filteredWhatsNews.map(whatsNew => (
                                <TableRow hover={true} key={whatsNew.Id} onClick={(ev: React.MouseEvent<HTMLTableRowElement, MouseEvent>) => _handleRowClick(ev, whatsNew)} className={classes.tablerow}>
                                    <CustomTableCell>{whatsNew.Id}</CustomTableCell>
                                    <CustomTableCell>{whatsNew.Version}</CustomTableCell>
                                    <CustomTableCell>{whatsNew.Title}</CustomTableCell>
                                    <CustomTableCell>{whatsNew.HtmlContent}</CustomTableCell>
                                    <CustomTableCell>{whatsNew.ExpirationDate}</CustomTableCell>
                                    <CustomTableCell>
                                        <div style={{display: 'flex', flexDirection: 'row'}}>
                                            <BlockIcon className={classes.buttonIcon} titleAccess="Termina news" color="primary" onClick={(ev: React.MouseEvent<HTMLTableRowElement, MouseEvent>) => handleCloseNews(ev, whatsNew)}/>
                                            <OpenIcon className={classes.buttonIcon} titleAccess="Riapri news" color="primary" onClick={(ev: React.MouseEvent<HTMLTableRowElement, MouseEvent>) => handleOpenNews(ev, whatsNew)}/>
                                        </div>
                                    </CustomTableCell>
                                </TableRow>
                            ))) 
                            : <CustomTableRow>
                                <CustomTableCell colSpan={5}>
                                    <Typography variant="h6" color="textSecondary">{loadingWhatsNews ? "Caricamento..." : "Nessun dato da visualizzare"}</Typography>
                                </CustomTableCell>
                            </CustomTableRow>}
                        </TableBody>
                        <TableFooter>
                            <CustomTableRow>
                                <CustomTableCell colSpan={6}>
                                    <TablePagination
                                        rowsPerPageOptions={[10,20,30, { label: 'All', value: -1 }]}
                                        count={filteredWhatsNews ? filteredWhatsNews.length : 0}
                                        rowsPerPage={pagination.rowsPerPage}
                                        page={pagination.page}
                                        SelectProps={{native: true,}}
                                        onChangePage={_handleChangePage}
                                        onChangeRowsPerPage={_handleChangeRowsPerPage}
                                        //ActionsComponent={TablePaginationActions}
                                        labelRowsPerPage="Righe per pagina"
                                        labelDisplayedRows={({ from, to, count }) => count ? `${from}-${to} di ${count}` : ""}
                                        component='div'
                                        style={{display: 'flex'}}
                                    />
                                </CustomTableCell>
                            </CustomTableRow>
                        </TableFooter>
                    </Table>
                </Paper>
            </div>
        </Main>
        <ConfirmDialog open={confirmDialogOpen} cancel={closeConfirmDialog} confirm={confirmCloseNews} 
            title={'Chiusura News'} 
            prompt={"Chiusura?"}>
            <>
                <Typography variant='body1'>{'Termino la News: '} <strong>{newsInClosing ? newsInClosing.Title : ''}</strong></Typography>
                <p></p>
            </>
        </ConfirmDialog>
        <ConfirmDialog open={openConfirmDialogOpen} cancel={closeOpenConfirmDialog} confirm={confirmOpenNews} 
            title={'Riapertura News'} 
            prompt={"Apertura?"}>
            <>
                <Typography variant='body1'>{'Riapro la News: '} <strong>{newsInClosing ? newsInClosing.Title : ''}</strong></Typography>
                <p></p>
            </>
        </ConfirmDialog>
    </div>
  );
}